import React, { useEffect, useState, useRef } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { API_BASE_URL } from '../config';

const ConfirmNewEmail: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<'pending' | 'success' | 'error'>('pending');
  const hasRun = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      return;
    }

    fetch(`${API_BASE_URL}/auth/confirm-new-email?token=${token}`)
      .then(res => res.json())
      .then(data => {
        if (data.message) {
          setStatus('success');
          Swal.fire({
            title: 'Email Updated',
            text: data.message,
            icon: 'success',
            confirmButtonText: 'Go to Home',
            customClass: {
              confirmButton: 'bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded'
            },
            buttonsStyling: false
          }).then(() => {
            navigate('/');
          });
        } else {
          setStatus('error');
          Swal.fire({
            title: 'Error',
            text: data.error || 'Invalid token',
            icon: 'error',
            confirmButtonText: 'OK',
            customClass: {
              confirmButton: 'bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded'
            },
            buttonsStyling: false
          }).then(() => {
            navigate('/');
          });
        }
      })
      .catch(() => {
        setStatus('error');
        Swal.fire({
          title: 'Error',
          text: 'Something went wrong',
          icon: 'error',
          confirmButtonText: 'OK',
          customClass: {
            confirmButton: 'bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded'
          },
          buttonsStyling: false
        }).then(() => {
          navigate('/');
        });
      });
  }, [searchParams, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      {status === 'pending' && <p className="text-gray-700 text-lg">Verifying...</p>}
      {status === 'success' && <p className="text-green-600 text-lg">Email confirmed successfully 🎉</p>}
      {status === 'error' && <p className="text-red-500 text-lg">Verification failed ❌</p>}
    </div>
  );
};

export default ConfirmNewEmail;
